import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import './solar-icons'
import './styles/base.css'
import 'katex/dist/katex.min.css'

document.documentElement.dataset.build = '2026-09-19-light-professor'
createApp(App).use(createPinia()).use(router).mount('#app')
